import { HeartIcon } from './HeartIcon';

/**
 * author: Google
 * id 32B56DB2-B6BF-4B54-AD0C-9444106B1C1D
 * name heart
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/heart.svg
 * tags
 * - Shape 
 * - Gaming / RPG 
 * - Medical / Hospital 
 */
export const FavoriteIcon = HeartIcon;
export default FavoriteIcon